import React from "react";
const TermSection = () => {
  return (
    <section className="term-section">
      <div className="container">
        <div className="term-content">
          <h2>Terms & Conditions</h2>
          <h4>1. <span>Acceptance of Terms</span></h4>
          <p>
            By accessing and using our website, you acknowledge that you have
            read, understood, and agree to be bound by these Terms and
            Conditions. If you do not agree to these terms, please refrain from
            using our website.
          </p>
          <p>
            These Terms & Conditions apply to all users of our website,
            including browsers, customers, and merchants. By using our site, you
            agree to these terms, our Privacy Policy, and any other policies
            referenced here.
          </p>
          <h4>2. <span>Products & Services</span></h4>
          <ul>
            <li>
              We strive to display accurate product descriptions, images, and
              prices.
            </li>
            <li>Prices are subject to change without notice.</li>
            <li>
              Products may be temporarily unavailable due to supply chain issues
              or other factors.
            </li>
          </ul>
          <h4>3. <span>Orders & Payments</span></h4>
          <ul>
            <li>
              We accept various payment methods, including credit cards, debit
              cards, and digital wallets.
            </li>
            <li>
              Payment information is encrypted and protected to ensure your
              security.
            </li>
            <li>
              By providing payment information, you confirm your authorization
              for the transaction.
            </li>
            <li>All orders are subject to acceptance and availability.</li>
            <li>
              We reserve the right to cancel any order due to errors, suspected
              fraud, or stock unavailability.
            </li>
            <li>
              Once your order is placed, you’ll receive an email confirmation.
            </li>
          </ul>
          <h4>4. <span>Shipping & Delivery</span></h4>
          <ul>
            <li>
              Delivery timelines may vary depending on your location and chosen
              shipping method.
            </li>
            <li>
              We are not liable for delays caused by courier services or
              unforeseen circumstances.
            </li>
            <li>
              Please ensure your shipping details are accurate at checkout.
            </li>
          </ul>
          <h4>5. <span>Returns & Refunds Policy</span></h4>
          <ul>
            <li>
              We accept returns for damaged, defective, or incorrect items
              within 7 days of delivery.
            </li>
            <li>Returned items must be unused and in original packaging.</li>
            <li>
              Refunds are processed to the original payment method once the
              product is inspected and approved.
            </li>
            <li>
              For more information, please refer to our Return & Refund Policy.
            </li>
          </ul>
          <h4>6. <span>User Responsibilities</span></h4>
          <p>You agree not to:</p>
          <ul>
            <li>Use the website for any unlawful purpose.</li>
            <li>Attempt to gain unauthorized access to our systems.</li>
            <li>Upload viruses or malicious code.</li>
            <li>
              Copy, reproduce, or distribute our content without permission.
            </li>
          </ul>
          <h4>7. <span>Limitation of Liability</span></h4>
          <p>
            We are not responsible for any indirect, incidental, or
            consequential damages arising from the use or inability to use our
            products or services.
          </p>
          <h4>8. <span>Contact Us</span></h4>
          <p>
            If you have any questions about these Terms and Conditions, please
            contact us:
          </p>
          <ul className="termcontact-list">
            <li>
              <a href="/">carap.com</a>
            </li>
            <li>
              <a href="mailto:carapglobal@gmail.com">carapglobal@gmail.com</a>
            </li>
            <li>
              <a href="tel:+971503580352">+971503580352</a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
export default TermSection;
